import { render, staticRenderFns } from "./unbindDetail.vue?vue&type=template&id=8ead4724"
import script from "./unbindDetail.vue?vue&type=script&lang=js"
export * from "./unbindDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports